import React, {createContext, useContext, useState, ReactNode} from 'react';

interface SyncContextType {
  syncDisabled: boolean;
  setIntervalSyncDisabled: (disabled: boolean) => void;
}

const SyncContext = createContext<SyncContextType | undefined>(undefined);

export const SyncProvider = ({children}: {children: ReactNode}) => {
  const [syncDisabled, setIntervalSyncDisabled] = useState(false);

  return (
    <SyncContext.Provider value={{syncDisabled, setIntervalSyncDisabled}}>
      {children}
    </SyncContext.Provider>
  );
};

export const useSyncControl = () => {
  const context = useContext(SyncContext);
  if (!context) {
    throw new Error('useSyncControl must be used within SyncProvider');
  }
  return context;
};
